import {FilterableMailBoxUrlSlugs} from "@twigsby/client-data";
import {useMailbox} from "../../../Providers/NewMailboxProvider";
import {ActiveFilterPills} from "../../Filter/ActiveFilterPills";
import {ActiveFilterType, GenericFilterType} from "../../Filter/FilterTypes";

const MailFilterPills = (props: ActiveFilterType) => {
    const {
        userFilters,
        ClearFilters,
        RemoveFilter
    } = useMailbox();

    return (
        <ActiveFilterPills
            hideLabel={props.hideLabel}
            activeFilters={userFilters as Array<GenericFilterType>}
            removeFilterCallback={(key) => RemoveFilter(key as keyof FilterableMailBoxUrlSlugs)}
            clearFiltersCallback={() => ClearFilters()}
        />
    )
}

export { MailFilterPills }
